import React from 'react';
import './DescriptionPage.css';

function DataProcessingPolicyPage() {
  return (
    <div className="page-container description-page">
      <h1>Согласие на обработку персональных данных</h1>
      <p>Предоставляя свои персональные данные, вы соглашаетесь на их обработку в целях участия в исследовании.</p>
      <p>Обработка данных включает сбор, систематизацию, накопление и хранение информации для анализа результатов эксперимента.</p>
      <p>Все данные защищены техническими и организационными мерами безопасности.</p>
      <p>Вы можете отозвать согласие в любое время, направив запрос организаторам исследования.</p>
    </div>
  );
}

export default DataProcessingPolicyPage;